export const SORT_DIRECTIONS = ['asc', 'desc'] as const;

export type SortDirection = (typeof SORT_DIRECTIONS)[number];

export interface TableSort {
  columnId: string;
  direction: SortDirection;
}

export const ARIA_SORT_BY_DIRECTION: Record<SortDirection, 'ascending' | 'descending'> = {
  asc: 'ascending',
  desc: 'descending',
};

export function getNextTableSort(
  currentSort: TableSort | undefined,
  columnId: string,
): TableSort | undefined {
  if (currentSort?.columnId !== columnId) return { columnId, direction: 'asc' };
  if (currentSort.direction === 'asc') return { columnId, direction: 'desc' };
  return undefined;
}
